import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { ArchiveService } from '../../../services/archive.service';

interface ArchiveableItem {
  id: number;
  type: string;
  state: 'published' | 'archived';
  current_user_permissions: {
    archive: boolean;
  };
}

@Component({
  selector: 'ut-community-archive-btn',
  templateUrl: './community-archive-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CommunityArchiveBtnComponent implements OnInit {
  @Input() item!: ArchiveableItem;
  @Output() stateChanged = new EventEmitter<void>();

  processing = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private archiveService: ArchiveService,
    @Inject('AlertService') private AlertService: any,
  ) {}

  ngOnInit(): void {
    this.processing = false;
  }

  getTitle(): string {
    if (this.item.state === 'archived') {
      return 'Unarchive';
    }
    return 'Archive';
  }

  toggleArchiveStatus(): void {
    if (!this.processing && this.item.state !== undefined) {
      this.processing = true;
      this.cdr.markForCheck();

      if (this.item.state === 'published') {
        this.archiveService.archive(this.item)
          .then((res: any) => this.successCallback(res))
          .catch(() => this.errorCallback());
      } else {
        this.archiveService.unarchive(this.item)
          .then((res: any) => this.successCallback(res))
          .catch(() => this.errorCallback());
      }
    }
  }

  private successCallback(res: any): void {
    Object.assign(this.item, res.data);
    if (this.item.state === 'archived') {
      this.AlertService.add(`You successfully archived this ${this.item.type}`);
    } else {
      this.AlertService.add(`You successfully unarchived this ${this.item.type}`);
    }
    this.processing = false;
    this.stateChanged.emit();
    this.cdr.markForCheck();
  }

  private errorCallback(): void {
    this.processing = false;
    this.AlertService.add('Request failed', 'danger');
    this.cdr.markForCheck();
  }
}
